import { object, string } from 'yup';
import { ForgotPasswordFormType } from './types';
import i18n from '../../../i18n';

export const ForgotPasswordFormSchema = object<ForgotPasswordFormType>({
  email: string()
    .email(() => i18n.t('validation:emailFormat'))
    .required(() => i18n.t('validation:emailMandatory')),
});
